import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/components/../assets/converza_icon_only.svg'


const _hoisted_1 = { class: "flex-1 bg-gray-200 max-md:space-y-4 max-md:py-2 md:flex md:flex-row md:items-center md:justify-around md:gap-4 md:px-4 md:flex-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-10",
  alt: "Converza Icon"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg mb-2" }, " Fluxos ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("section", { class: "max-w-1/2 text-left font-semibold text-xs space-y-4 m-auto" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Automatize a resposta de seus clientes antes mesmo de atender. "),
  /*#__PURE__*/_createElementVNode("p", null, " Crie fluxos de conversas e deixe que o Converza atenda seus clientes. "),
  /*#__PURE__*/_createElementVNode("p", null, " Automatize respostas e coleta de dados ao definir fluxos. ")
], -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "h-12 w-12 bg-blue-200 group-hover:bg-white text-primary rounded-full flex justify-center items-center" }
const _hoisted_7 = { class: "flex-1 flex flex-col items-start justify-evenly gap-3 py-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-left text-xs p-0"
}

import Button from '@/components/ui/button/Button.vue';
import Card from '@/components/ui/card/Card.vue';
import CardHeader from '@/components/ui/card/CardHeader.vue';
import CardTitle from '@/components/ui/card/CardTitle.vue';
import CardContent from '@/components/ui/card/CardContent.vue';
import { createNewWorkflow, getWorkflows, Workflow, WorkflowCreationRequest } from '@/http/workflow';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { GET_CREDENTIALS, GET_PARTNER_ID, PARTNER_ID } from '@/store';
import { get, set } from '@vueuse/core';
import { useRouter } from 'vue-router';
import { Bot } from 'lucide-vue-next';
import WorkflowCreationDialog from '@/components/automations-screen/WorkflowCreationDialog.vue';
import { predefinedWorkflows } from '@/lib/workflow';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutomationMenu',
  setup(__props) {

const { getters } = useStore();
const router = useRouter();
const workflows = ref<Workflow[]>([]);
const didQuery = ref(false);


const isModalCreationOpen = ref(false);
const isWorkflowDataValid = ref(false);
const validationErrorMessage = ref('');

const validateWorkflowData = (workflowData: WorkflowCreationRequest) => {
    if (workflowData.presentationName === '') {
        validationErrorMessage.value = 'O nome não pode ser vazio!';
        return false;
    }

    if (workflows.value === undefined) return;

    const workflowExists = workflows.value.filter(workflow => workflow.presentationName === workflowData.presentationName).length > 0;
    if (workflowExists) {
        validationErrorMessage.value = 'Este nome já existe!';
        return false;
    }

    return true;
};

const tryToSaveWorkflow = async (workflowData: WorkflowCreationRequest) => {
    if (!validateWorkflowData(workflowData)) {
        isWorkflowDataValid.value = false;
        return;
    }

    isWorkflowDataValid.value = true;

    const partnerId = getters[GET_PARTNER_ID];
    const credentials = getters[GET_CREDENTIALS];

    workflowData.partnerId = partnerId;

    const createdWorkflow = await createNewWorkflow(workflowData, credentials);

    isModalCreationOpen.value = false;

    await router.push({ path: '/dashboard/automacoes/' + createdWorkflow.workflowCode.replace('#', '%23') });
};

onMounted(async () => {
    set(workflows, await getWorkflows(getters[PARTNER_ID], getters[GET_CREDENTIALS]));
    set(workflows, get(workflows)?.filter(w => predefinedWorkflows.includes(w.workflowCode)));
    setTimeout(() => {
        set(didQuery, true);
    }, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Card, { class: "md:flex-1 md:grow md:h-80 md:max-w-2/3 md:m-0 max-md:w-2/3 max-md:m-auto" }, {
      default: _withCtx(() => [
        _createVNode(CardTitle, { class: "flex flex-row gap-2 items-center self-center max-w-1/2 p-5" }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(CardContent, { class: "flex-1 flex-grow-[2] flex flex-col gap-6 max-w-2/3 h-3/4 m-auto" }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(WorkflowCreationDialog, {
              isModalCreationOpen: isModalCreationOpen.value,
              "onUpdate:isModalCreationOpen": _cache[1] || (_cache[1] = ($event: any) => ((isModalCreationOpen).value = $event)),
              isWorkflowDataValid: isWorkflowDataValid.value,
              "onUpdate:isWorkflowDataValid": _cache[2] || (_cache[2] = ($event: any) => ((isWorkflowDataValid).value = $event)),
              validationErrorMessage: validationErrorMessage.value,
              "onUpdate:validationErrorMessage": _cache[3] || (_cache[3] = ($event: any) => ((validationErrorMessage).value = $event)),
              onTryToSaveWorkflow: tryToSaveWorkflow
            }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  disabled: "",
                  class: "rounded-full max-w-1/2 m-auto",
                  variant: "default",
                  onClick: _cache[0] || (_cache[0] = () => isModalCreationOpen.value = true)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Comece a automatizar ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["isModalCreationOpen", "isWorkflowDataValid", "validationErrorMessage"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Card, { class: "md:flex-1 md:grow md:h-80 md:m-0 md:max-w-1/3 max-md:m-auto max-md:w-2/3" }, {
      default: _withCtx(() => [
        _createVNode(CardHeader, null, {
          default: _withCtx(() => [
            _createVNode(CardTitle, null, {
              default: _withCtx(() => [
                _createTextVNode("Automações")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(CardContent, { class: "overflow-y-auto h-56 space-y-4" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workflows.value, (workflow) => {
              return (_openBlock(), _createBlock(Card, {
                key: workflow.id
              }, {
                default: _withCtx(() => [
                  _createVNode(CardContent, { class: "group py-2 pl-4 pr-2 hover:bg-blue-200 overflow-y-auto" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: async () => await _unref(router).push('/dashboard/automacoes/' + workflow.workflowCode.replace('#', '%23')),
                        class: "flex flex-row flex-nowrap items-center justify-between gap-3"
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_unref(Bot))
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(CardHeader, { class: "p-0" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(workflow.presentationName ?? workflow.workflowCode), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (workflow.notes != undefined)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(workflow.notes), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_5)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})